import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Indicador de carregamento compartilhado pelas telas de listagem -
 * substitui a tabela/grid enquanto a requisição ao backend está em
 * andamento (carga inicial, troca de página, busca ou filtro).
 */
const LoadingBox = ({ label }) => (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={6} gap={1.5}>
        <CircularProgress size={28} />
        <Typography variant="body2" color="text.secondary">
            {label}
        </Typography>
    </Box>
);

LoadingBox.propTypes = {
    label: PropTypes.string
};

LoadingBox.defaultProps = {
    label: 'Carregando...'
};

export default LoadingBox;
